













import Vue from 'vue';
import TMAlert from '@/tools/models/TMAlert';

export default Vue.extend({
  computed: {
    alert(): TMAlert {
      return this.$store.getters.alert;
    },
    initialMessageShown(): boolean {
      return this.$store.getters.initialMessageShown;
    },
  },
  methods: {
    closeAlert(): void {
      this.$store.dispatch('setAlert', new TMAlert());
    },
  },
});
